import grooveAPI from 'api/groove'

import { oauthTokenSelector } from 'selectors/app'

import {
  FETCH_INTEGRATION_SETTINGS_ERROR,
  FETCH_INTEGRATION_SETTINGS_RESPONSE,
  FETCH_INTEGRATION_SETTINGS_REQUEST,
} from '../types'

export default function doFetchIntegrationSettings() {
  return (dispatch, getState) => {
    const token = oauthTokenSelector(getState())
    dispatch({
      type: FETCH_INTEGRATION_SETTINGS_REQUEST,
    })
    grooveAPI
      .get(token, `v2/integration_settings`)
      .then(({ json: { integration_settings: payload } }) => {
        dispatch({
          payload,
          type: FETCH_INTEGRATION_SETTINGS_RESPONSE,
        })
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error)
        dispatch({
          error: true,
          type: FETCH_INTEGRATION_SETTINGS_ERROR,
          payload: error,
        })
      })
  }
}
